import { useNavigate } from 'react-router-dom'

export const SHIPMENT_PREPARATION_URL =
  '/shipment/:transferId/:docNum/preparation'

export const useGoToShipmentPreparation = () => {
  const navigate = useNavigate()

  return {
    go: (transferId: string, docNum: string) => {
      navigate(
        SHIPMENT_PREPARATION_URL.replace(':transferId', transferId).replace(
          ':docNum',
          docNum
        )
      )
    }
  }
}
